export const validatePasswordMatch = (password, confirmPassword) => {
    if (password !== confirmPassword) {
        return "رمز عبور و تأیید رمز عبور یکسان نیستند";
    }
    return "";
};
